<template>
  <div class="bg">
    <!-- 搜索栏 -->
    <div class="top_search_part">
      <div class="search_box">
        <div class="search_item">
          <el-input v-model="signatureName" :placeholder="$t('message.signatureSearchPlaceholder')"></el-input>
        </div>
        <div class="search_item">
          <el-input v-model="signatureNum" :placeholder="$t('message.signatureSearchPlaceholder2')" /></el-input>
        </div>
        <div class="search_item">
          <el-input v-model="orderNum" :placeholder="$t('message.orderSearchPlaceholder')" /></el-input>
        </div>
        <div class="search_btn" @click="searchSignatureForm">{{$t('message.searchBtnText')}}</div>
        <div class="add_btn" @click="addNewForm"><img class="add_icon" src="@/assets/addIcon.svg" />{{$t('message.addSignatureBtnText')}}</div>
      </div>
    </div>
    <!-- 搜索栏 -->
    <!-- 列表 -->
    <!-- 签收单管理列表 -->
    <div class="content">
      <div class="tableBox">
        <el-table id="signatureList" :data="signatureList" style="width: 100%" stripe size="small" header-cell-class-name="tableHeader" cell-class-name="tableBodyer" height="100%" @sort-change="sortChange">
          <el-table-column :label="$t('message.customTableTitle1')" prop="index" width="85"></el-table-column>
          <el-table-column :label="$t('message.signatureFormName')" prop="QSDNAME" min-width="120"></el-table-column>
          <el-table-column :label="$t('message.signatureNumTitle')" prop="GUID" min-width="150"></el-table-column>
          <el-table-column :label="$t('message.signatureOrderTitle')" width="120">
            <template slot-scope="scope">
              <!-- 是否有子订单 -->
              <div class="operate_btn_box" v-if="scope.row.ORDERNO === 0 && scope.row.STATE === '1'">
                <el-button class="operation_a_blue" type="text" @click.native.prevent="goSignatureOrder(scope.row)">{{$t('message.signatureNotOrder')}}</el-button>
              </div>
              <div class="operate_btn_box" v-else>
                <el-button class="operation_a_blue" type="text" @click.native.prevent="checkChildOrder(scope.row)">{{$t('message.signatureHasOrder')}}</el-button>
              </div>
            </template>
          </el-table-column>
          <el-table-column :label="$t('message.signatureOrderImgTitle')" width="120">
            <template slot-scope="scope">
              <!-- 是否有图片 -->
              <div class="operate_btn_box" v-if="scope.row.PICNO === 0 && scope.row.STATE === '1'">
                <el-button class="operation_a_blue" type="text" @click.native.prevent="goSignatureImg(scope.row)">{{$t('message.signatureNotOrder')}}</el-button>
              </div>
              <div class="operate_btn_box" v-else>
                <el-button class="operation_a_blue" type="text" @click.native.prevent="goSignatureImg(scope.row)">{{$t('message.signatureHasOrder')}}</el-button>
              </div>
            </template>
          </el-table-column>
          <el-table-column :label="$t('message.signatureAddUserTitle')" prop="GUDING1" width="140"></el-table-column>
          <el-table-column :label="$t('message.signatureAddTimeTitle')" prop="addTime" min-width="150" sortable="custom"></el-table-column>
          <el-table-column :label="$t('message.signatureStateTitle')" prop="status" width="100"></el-table-column>
          <el-table-column :label="$t('message.customTableTitle5')" width="200" fixed="right" >
            <template slot-scope="scope">
              <div class="operate_btn_box">
                <a class="operation_a_blue" target="_blank" :href="url + '/pdf/pdf?pid=' + scope.row.GUID">pdf</a>
                <el-button class="operation_btn updateBtn" type="text" size="small" @click.native.prevent="endSignature(scope.row)" v-if="scope.row.STATE === '1'"></el-button>
                <el-button class="operation_btn delBtn" type="text" size="small" @click.native.prevent="delSignature(scope.row)"></el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <el-pagination
        @size-change="sizeChange"
        @current-change="currentChange"
        :current-page="page_no"
        :page-sizes="pageSizes"
        :page-size="page_size"
        layout="total, sizes, prev, pager, next"
        :total="totalSize"
        class="tablePage">
      </el-pagination>
    </div>
    <!-- 签收单管理列表 -->
    <!-- 列表 -->
    <el-dialog :title="$t('message.addSignatureBtnText')" :visible.sync="newSignsture" width="30%" destroy-on-close :close-on-click-modal="false" center :modal-append-to-body="false">
      <!-- fullscreen -->
      <div class="dialog_box">
        <div class="dialog_row">
          <div class="dialog_item">
            <span class="dialog_item_title">{{$t('message.signatureFormName')}}</span>
            <el-input v-model="newSignatureName" :placeholder="$t('message.placeholder')"></el-input>
          </div>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="newSignsture = false">{{$t('message.cancleText')}}</el-button>
          <el-button type="primary" @click="addNewConfirm">{{$t('message.confirmText')}}</el-button>
        </span>
      </div>
    </el-dialog>
    <el-dialog :title="$t('message.signOrderTitleText')" :visible.sync="showSignOrder" width="80%" destroy-on-close :close-on-click-modal="false" center :modal-append-to-body="false">
      <!-- 签收单管理列表 -->
      <div class="content">
        <el-table id="signOrderList" :data="signOrderList" style="width: 100%">
          <el-table-column :label="$t('message.customTableTitle1')" prop="index" width="130"></el-table-column>
          <el-table-column :label="$t('message.orderTableTitle1')" prop="ORDERNUM" min-width="130"></el-table-column>
          <el-table-column :label="$t('message.orderTableTitle10')" prop="status" min-width="100"></el-table-column>
          <el-table-column :label="$t('message.orderTableTitle4')" prop="JJGS" min-width="130"></el-table-column>
          <el-table-column :label="$t('message.addresseeCompanyTitle')" prop="SJGS" min-width="130"></el-table-column>
          <el-table-column :label="$t('message.orderTableTitle7')" prop="WPSL" width="120"></el-table-column>
          <el-table-column :label="$t('message.orderTableTitle8')" prop="WPZL" width="120"></el-table-column>
          <el-table-column :label="$t('message.orderTableTitle9')" prop="WPTJ" width="120"></el-table-column>
          <el-table-column :label="$t('message.customTableTitle5')" width="100">
            <template slot-scope="scope">
              <div class="operate_btn_box">
                <el-button class="operation_a_blue" type="text" size="small" @click.native.prevent="checkLogistics(scope.row.ORDERNUM)">{{$t('message.signatureHasOrder')}}</el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!-- 签收单管理列表 -->
    </el-dialog>
    <el-dialog :title="$t('message.deliveryStatusTitle')" :visible.sync="showLogistics" destroy-on-close :close-on-click-modal="false">
      <div class="content">
        <el-timeline>
          <el-timeline-item v-for="(logistics, index) in logisticsList" :key="index" :timestamp="logistics.RQ">{{logistics.GUDING1}}</el-timeline-item>
        </el-timeline>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import { getSignatureList, setSignatureForm, delSignatureForm, endSignatureForm, getSignOrders, getLogisticsDetails, HTTPS } from '@/api/getData.js'
  export default {
    name: 'signatureFormManage',
    data () {
      return {
        page_no: 1,
        page_size: 10,
        pageSizes: [10, 20, 30, 50, 100],
        totalSize: 0,
        signatureList: [],
        signatureName: '',
        signatureNum: '',
        orderNum: '',
        prop: null,
        order: '',
        newSignsture: false,
        newId: 0,
        newSignatureName: '',
        signOrderList: [],
        showSignOrder: false,
        showLogistics: false,
        logisticsList: []
      }
    },
    created() {
      let param = this.$store.state.JHSS_signManage_param
      if (param.PAGE) this.page_no = param.PAGE
      if (param.TYPE) this.page_size = param.TYPE
      if (param.QSDNAME) this.signatureName = param.QSDNAME
      if (param.GUID) this.signatureNum = param.GUID
      if (param.CID) this.orderNum = param.CID
      // 查询订单列表
      this.getSignatureList(param)
    },
    methods: {
      async getSignatureList (param) {
        const loading = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        })
        param = param || {}
        if (this.prop) {
          param.ORDERNAME = this.prop
        }
        param.DOA = this.order
        param.PAGE = this.page_no
        param.TYPE = this.page_size
        let res = await getSignatureList(param)
        loading.close()
        if (res.status !== 200) {
          this.$message.error('network error：' + res.status)
          return
        }
        // console.log(res.data.dt)
        this.totalSize = res.data.num
        let index = (this.page_no - 1) * this.page_size
        this.signatureList = res.data.dt.map(item => {
          item.index = ++index
          item.status = item.STATE === '2' ? this.$t('message.signatureStatusTitle2') : this.$t('message.signatureStatusTitle1')
          item.addTime = item.ADDTIME.replace(/T/g, ' ')
          return item
        })
        this.$store.commit('setSignManageParam', param)
      },
      searchSignatureForm () {
        this.page_no = 1
        this.searchFun()
      },
      sizeChange (val) {
        // console.log(val)
        this.page_size = val
        this.page_no = 1
        this.searchFun()
      },
      currentChange (val) {
        // console.log(val)
        this.page_no = val
        this.searchFun()
      },
      searchFun () {
        let param = {}
        // 查询客户管理
        if (this.signatureName) {
          param.QSDNAME = this.signatureName
        }
        if (this.signatureNum) {
          param.GUID = this.signatureNum
        }
        if (this.orderNum) {
          param.CID = this.orderNum
        }
        this.getSignatureList(param)
      },
      // 新建签收单
      addNewForm () {
        this.newId = 0
        this.newSignatureName = ''
        this.newSignsture = true
      },
      // 确定添加订单
      async addNewConfirm () {
        if (!this.newSignatureName) {
          this.$message.error(this.$t('message.signatureFormName'))
        } else {
          const loading = this.$loading({
            lock: true,
            text: 'Loading',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
          })
          let param = {
            ID: this.newId,
            QSDNAME: this.newSignatureName,
            ADDUSER: this.$store.state.JHSS.personalUserid,
            GUDING1: this.$store.state.JHSS.personalAccount
          }
          let res = await setSignatureForm(param)
          loading.close()
          if (res.status !== 200) {
            this.$message.error('network error：' + res.status)
            return
          }
          // console.log(res.data)
          if (res.data.result !== '1') {
            this.$message.error(res.data.message)
          } else {
            this.newSignsture = false
            this.page_no = 1
            this.getSignatureList()
          }
        }
      },
      // 删除签收单
      delSignature (obj) {
        // console.log(obj)
        this.$confirm(this.$t('message.signaturePrompt'), this.$t('message.promptTitle'), {
          closeOnClickModal: false,
          confirmButtonText: this.$t('message.confirmText'),
          cancelButtonText: this.$t('message.cancleText')
        }).then(() => {
          this.del(obj.ID)
        }).catch(() => {
          this.$message(this.$t('message.canclePrompt'));
        });
      },
      async del (id) {
        let param = { ID: id }
        let res = await delSignatureForm(param)
        if (res.status !== 200) {
          this.$message.error('network error：' + res.status)
          return
        }
        if (res.data.result !== '1') {
          this.$message.error(res.data.message)
        } else {
          // this.page_no = 1
          // this.getSignatureList()
          this.searchFun()
        }
      },
      // 完善签收单订单
      goSignatureOrder (obj) {
        // console.log(obj)
        if (obj.STATE === '2') {
          this.$router.push({ path: '/signOrder', query: { GUID: obj.GUID, hasOrder: 1 } })
        } else {
          this.$router.push({ path: '/signOrder', query: { GUID: obj.GUID, hasOrder: obj.ORDERNO } })
        }
      },
      // 完善签收单图片
      goSignatureImg (obj) {
        if (obj.STATE === '2') {
          this.$router.push({ path: '/signImg', query: { GUID: obj.GUID, hasImg: 1 } })
        } else {
          this.$router.push({ path: '/signImg', query: { GUID: obj.GUID, hasImg: obj.PICNO } })
        }
      },
      // 完结签收单
      endSignature (obj) {
        this.$confirm(this.$t('message.endSignatureTitle'), this.$t('message.promptTitle'), {
          closeOnClickModal: false,
          confirmButtonText: this.$t('message.confirmText'),
          cancelButtonText: this.$t('message.cancleText')
        }).then(() => {
          this.end(obj.ID)
        }).catch(() => {
          this.$message(this.$t('message.canclePrompt'));
        });
      },
      async end (id) {
        let param = { ID: id, GUDING3: this.$store.state.JHSS.personalUserid }
        let res = await endSignatureForm(param)
        if (res.status !== 200) {
          this.$message.error('network error：' + res.status)
          return
        }
        if (res.data.result !== '1') {
          this.$message.error(res.data.message)
        } else {
          // this.page_no = 1
          this.getSignatureList()
        }
      },
      goPDF (pid) {
        window.location.href = HTTPS + "/pdf/pdf?pid=" + pid
      },
      // 时间排序
      sortChange (obj) {
        // console.log(obj)
        // 根据时间排序（prop: addTime ，order: 'ascending', 'descending', null）
        this.prop = null
        if (obj.prop === 'addTime') {
          this.prop = 'ADDTIME'
          // param.ORDERNAME = 'ADDTIME'
        }
        this.order = ''
        if (obj.order === 'descending') {
          this.order = 'DESC'
          // param.DOA = 'DESC'
        }
        // this.page_no = 1
        this.searchFun()
      },
      // 查看签收单子订单
      async checkChildOrder (obj) {
        const loading = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        })
        let param = { PID: obj.GUID }
        let res = await getSignOrders(param)
        loading.close()
        if (res.status !== 200) {
          this.$message.error('network error：' + res.status)
          return
        }
        let index = 0
        let orderState2 = this.$t('message.orderState2')
        let orderState1 = this.$t('message.orderState1')
        this.signOrderList = res.data.dt.map(item => {
          item.index = ++index
          item.status = item.STATE === '2' ? orderState2 : orderState1
          return item
        })
        this.showSignOrder = true
      },
      // 查看订单物流信息
      async checkLogistics (orderNum) {
        const loading = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        })
        let param = { PID: orderNum }
        let res = await getLogisticsDetails(param)
        loading.close()
        if (res.status !== 200) {
          this.$message.error('network error：' + res.status)
          return
        }
        // console.log(res.data)
        this.logisticsList = res.data.dt
        this.showLogistics = true
      }
    },
    computed: {
      url () {
        return HTTPS
      }
    }
  }
</script>

<style scoped>
/* 物流运输情况查看 */
/deep/ .el-timeline-item__content {
  font-size: 18px;
  color: #333333;
  line-height: 32px;
  text-align: left;
}
/deep/ .el-timeline-item__timestamp {
  font-size: 12px;
  color: #999999;
  line-height: 25px;
  text-align: left;
}
</style>
